define([
    "./commonsOperationModule",
    "./preViolationModal",
    "./organizeService",
    "./preValidationService"
], function () {
});